module.exports = __webpack_public_path__ + "static/media/27_Obayda_Syrische_Familie_webfinal.321e43c6.jpg";